export const bgcId = [
  'BGC0000006',
  'BGC0000149',
  'BGC0000002',
  'BGC0000004',
  'BGC0000018',
  'BGC0000146',
  'BGC0000003',
  'BGC0000183',
  'BGC0000184',
  'BGC0000005',
];
export default bgcId;
